import React from "react";

const GreenArrowUpIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_849_4122"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_849_4122)">
        <path
          d="M11.0008 8.80002L8.10078 11.7C7.91745 11.8834 7.68411 11.975 7.40078 11.975C7.11745 11.975 6.88411 11.8834 6.70078 11.7C6.51745 11.5167 6.42578 11.2834 6.42578 11C6.42578 10.7167 6.51745 10.4834 6.70078 10.3L11.3008 5.70002C11.5008 5.50002 11.7341 5.40002 12.0008 5.40002C12.2674 5.40002 12.5008 5.50002 12.7008 5.70002L17.3008 10.3C17.4841 10.4834 17.5758 10.7167 17.5758 11C17.5758 11.2834 17.4841 11.5167 17.3008 11.7C17.1174 11.8834 16.8841 11.975 16.6008 11.975C16.3174 11.975 16.0841 11.8834 15.9008 11.7L13.0008 8.80002V17C13.0008 17.2834 12.9049 17.5209 12.7133 17.7125C12.5216 17.9042 12.2841 18 12.0008 18C11.7174 18 11.4799 17.9042 11.2883 17.7125C11.0966 17.5209 11.0008 17.2834 11.0008 17V8.80002Z"
          fill="#00A305"
        />
      </g>
    </svg>
  );
};

export default GreenArrowUpIcon;
